export default __webpack_public_path__ + "static/media/calendar-active.70ed1e55.svg";